import React, { FC } from 'react'
import { componentConstructor } from '../../../GUIConstructor/control'
import { getRangeSchema } from '../Utils'

export const AdjustableRange: FC<any> = ({
    data,
    dataSchema = {},
    name = '',
    childrenPath,
    dataProp,
    blockState,
    levelDeep = 2,
    element_id,
    inCard,
    isRuleActive,
    pathWithElementID,
    builderType,
}) => (
    <>
        {componentConstructor({
            path: childrenPath,
            ProductScheme: getRangeSchema(dataSchema, data),
            ProductConfiguration: Object.keys(data || {}).length ? data : dataProp,
            name,
            builderType,
            wrapper: 'block',
            classname: '',
            isParentDisabled: !blockState,
            levelDeep: levelDeep + 1,
            element_id,
            inCard,
            isRuleActive,
            pathWithElementID,
        })}
    </>
)
